const fetchData = (productId: number, productGrId: string, action: 'add' | 'remove'): string => `
    {
        getResponse {
          updateProductInterest(productId: ${productId}, productGrId: "${productGrId}", action: "${action}")
        }
  }
`;
export default fetchData;
